import { render } from "./CategoryList.vue?vue&type=template&id=f3f7e164&scoped=true&ts=true"
import script from "./CategoryList.vue?vue&type=script&lang=ts"
export * from "./CategoryList.vue?vue&type=script&lang=ts"

import "./CategoryList.vue?vue&type=style&index=0&id=f3f7e164&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3f7e164"]])

export default __exports__